const defaults = {
	input: '.chkBrochure',
	btnScroll: '[data-scroll]'
}

class Brochures {
	constructor(config) {
		/// On surcharge {config} par {defaults}
		/// les propriétés de {defaults} ne sont ajoutées que si elles n'existent pas
		this.config = {
			...defaults,
			...config
		};
	}

	initialize(idFormulaire) {

		$('#pano').css('background-image', 'url(' + this.config.urlPano + ')');

		if (this.config.page === 'brochures') {
			let fields = document.querySelectorAll(this.config.input);
			this.eventCheckLivret(fields);
			this.updateCart(fields);
			this.goToSection(document.querySelectorAll(this.config.btnScroll));
		} else if (this.config.page === 'magazine') {
			this.terre();
		}


		var formulaire = new Formulaire(settings);
		formulaire.initialize(idFormulaire);



		this.ajaxBrochure(idFormulaire);

		var complementAdresse = document.getElementById('complement');
		complementAdresse.addEventListener('change', function (el) {
			document.querySelector('[data-complement-checkbox]').checked = el.target.checked;
		})

	}

	ajaxBrochure(idFormulaire) {
		let self = this;
		document.querySelector('[data-form-submit]').addEventListener('click', function (e) {
			if (e.target.form.checkValidity()) {
				e.preventDefault();
				let data = {
					civilite: $("#Civilite").val(),
					nom: $("#Nom").val(),
					prenom: $("#Prenom").val(),
					adresse1: $("#Adresse1").val(),
					adresse2: $("#Adresse2").val(),
					adresse3: $("#NumeroLibelleVoie").val(),
					adresse4: $("#Adresse4").val(),
					codePostal: $("#CodePostal").val(),
					ville: $("#Ville").val(),
					pays: $("#Pays").val(),
					email: $("#Email").val(),
					telephonePortable: null,
					telephonePerso: null
				}
				if (settings.hasToken || settings.hasToken === undefined) {
					let tokenForm = document.getElementById('__AjaxAntiForgeryForm');
					let str = new URLSearchParams(new FormData(tokenForm));
					let token = str.get('__RequestVerificationToken');
					data.__RequestVerificationToken = token;
				}
				/// Liste des livrets sélectionnées
				let listeBrochures = [];
				let checkboxes = document.querySelectorAll(self.config.input);
				for (let checkbox of checkboxes) {
					checkbox.checked && listeBrochures.push(checkbox.value);
				}
				data.listeBrochure = listeBrochures.join(';');

				/// Abonnement
				let abonnement = 0;
				data.abonnement = abonnement;
				captchaModule.then((module) => {
					let captcha = new module();
					if (listeBrochures.length > 0) {
						captcha.initialize(self._callback,  {'data' : data, 'id': 'brochureMag'});
					}
					else {
						console.error('Aucune brochure ou magazine sélectionnée')
						document.getElementById('Brochure_validationMessage').innerHTML = "Veuillez sélectionner au moins une brochure ou un magazine"
					}
			 });
			}
		})
	}

	_callback(obj) {
		$.ajax({
			url: settings.url,
			data: obj.data,
			type: "POST",
			success: function (j) {
				if (j.ErrorEmail == true) {
					$("#Email_validationMessage").text("Email invalide");
				} else {
					let content = document.getElementById('confirmation').innerHTML;
					modalPopup.init(content, 'Commande bien envoyée', '', '');
					document.getElementById('Brochure_validationMessage').innerHTML = "";
					$("#btEnvoyer").hide();
				}
			},
			error: function () {
				alert("Une erreur est survenu,l'enregistrement de votre commande n'a pas pu aboutir");
			}
		});
	}
	_setLibelle(a) {
		// variable
		let input = a.target,
			nomPubli = input.parentElement.querySelector('.print--title'),
			libelle = '';

		if (input.checked) {
			nomPubli.classList.add('weight--normal');
			libelle = 'Commandé';
		} else {
			nomPubli.classList.remove('weight--normal');
			libelle = nomPubli.title;
		}
		nomPubli.textContent = libelle;
	}

	eventCheckLivret(fields) {
		let self = this;

		fields.forEach(el => {
			el.addEventListener('change', function (element) {
				self._setLibelle(element);
				self.updateCart(fields);
			});
		});
	}

	updateCart(fields) {
		// variables
		let nbreLivrets = 0,
			nbreMags = 0,
			panier = [],
			libelleMag = ' magazine',
			libelleLivret = ' brochure',
			toto = [],
			cartIsEmpty = true;

		fields.forEach(el => {
			let typePubli = el.name;

			if (el.checked && typePubli === 'mag') {
				nbreMags++;
			}
			if (el.checked && typePubli === 'brochure') {
				nbreLivrets++;
			}

			if (el.checked) {
				toto.push(false);
			} else {
				toto.push(true);
			}

			cartIsEmpty = toto.every(bool => bool);
		});

		libelleMag = nbreMags > 1 ? libelleMag + 's' : libelleMag;
		libelleLivret = nbreLivrets > 1 ? libelleLivret + 's' : libelleLivret;
		let magazine = nbreMags === 0 ? '' : nbreMags + libelleMag;
		let brochure = nbreLivrets === 0 ? '' : nbreLivrets + libelleLivret;
		let et = nbreMags > 0 && nbreLivrets > 0 ? ' et ' : '';

		// Le texte des livrets et mag sélectionnés
		panier.push(magazine + et + brochure + '.');
		document.getElementById('livretsMagsCommandes').textContent = magazine + et + brochure + '.';

		document.getElementById('livretsMagsCommandes').parentElement.style.display = cartIsEmpty ? 'none' : 'block';
	}

	goToSection(el) {
		el.forEach(element => {
			element.addEventListener('click', function (e) {
				e.preventDefault();
				let element = document.querySelector(e.target.hash);
				element.scrollIntoView({
					behavior: 'smooth'
				});
			})
		})
	}

	terre() {
		$('#thumbnails').lightGallery({
			download: false,
			zoom: false
		});

		$('.lazy').lazyload();

		$('a[href="#detailsNumero"]').on('click', function () {
			var img = $('#thumbnails').find('img');
			$.each(img, function () {
				var dataOriginal = $(this).attr('data-original');
				$(this).attr('src', dataOriginal);
			});
			$('#thumbnails a').first().trigger('click');
			return false;
		});

		var clickSocial = function (a, w, h) {
			window.open(a.attr('href'), 'popupWindow', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=' + h + 'px,width=' + w + 'px');
		};

		var socialShareButtonsNavbar = function (params) {
			// Paramètres
			var params = $.extend({
				barreSocial: $('[data-hook="buttons-share"]'),
				breakpointMobile: 520,
				socialNetworksSize: {
					fb: '700, 500',
					tw: '700, 400',
					gp: '650, 450',
					pi: '650, 450'
				}
			}, params);
			if ($(window).width() < params.breakpointMobile)
				params.barreSocial.css('bottom', '0px').css('top', 'auto');

			params.barreSocial.find('a').on('click', function () {
				var $this = $(this),
					className = $this.attr('class').split(' '),
					className = className[1].split('--');
				switch (className[1]) {
				case 'fb':
					clickSocial($this, params.socialNetworksSize.fb);
					break;
				case 'tw':
					clickSocial($this, params.socialNetworksSize.tw);
					break;
				case 'gp':
					clickSocial($this, params.socialNetworksSize.gp);
					break;
				case 'pi':
					clickSocial($this, params.socialNetworksSize.pi);
					break;
				}
				if (!$this.hasClass('social--mail'))
					return false;
			});
		};

		socialShareButtonsNavbar();
	}
}